module.exports = __webpack_public_path__ + "img/Flag_of_Jamaica.f2883868.svg";